import { Form } from "react-bootstrap";
import "./LabelAndTextBox.css";
import React, { useState, useEffect } from "react";
import { Utils } from "../../../utilities/Utils";

interface DateBoxProps {
    title?: string;
    defaultValue?: string | Date | null;
    onChange: (value: Date) => void;
    disabled?: boolean;
}

const DateBox = ({ defaultValue, title, onChange, disabled }: DateBoxProps) => {
    // Convert defaultValue to a string if it's a Date.
    const rawDate = defaultValue instanceof Date 
        ? defaultValue.toISOString() 
        : defaultValue;

    // If the backend sends the uninitialized date, treat it as empty.
    const sanitizedDate = (rawDate && rawDate.startsWith("0000")) || !Utils.isDateInitialized(rawDate)
        ? ""
        : rawDate;

    const [submittedDate, setSubmittedDate] = useState(sanitizedDate);

    // Update internal state when defaultValue changes
    useEffect(() => {
        const newRawDate = defaultValue instanceof Date 
            ? defaultValue.toISOString() 
            : defaultValue;
        
        const newSanitizedDate = (newRawDate && newRawDate.startsWith("0000")) || !Utils.isDateInitialized(newRawDate)
            ? ""
            : newRawDate;
            
        setSubmittedDate(newSanitizedDate);
    }, [defaultValue]);

    return (
        <Form.Group className={disabled ? "disabled" : ""}>
            {title && <Form.Label className="fw-bold fs-5 mt-2">{title + ":"}</Form.Label>}
            <Form.Control
                className="date"
                type="date"
                style={{ maxWidth: '200px' }}
                value={submittedDate ? new Date(submittedDate).toISOString().split('T')[0] : ''}
                onChange={(event) => {
                    const value = event.target.value;
                    if (value) {
                        // Create a new date from the value. Since the input type is "date",
                        // it gives you a local date string. We convert it to ISO format.
                        const dateObject = new Date(value);
                        const isoDate = dateObject.toISOString().split('T')[0];
                        setSubmittedDate(isoDate);
                        onChange(dateObject);
                    } else {
                        setSubmittedDate("");
                    }
                }}
                disabled={disabled}
            />
        </Form.Group>
    );
};

export default DateBox;